import React, { createContext, useCallback, useMemo, useState } from 'react';
import './App.css';
import CampaignDetails from './order-details/page';
import CampaignPayment from './order-details/payment';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react'
import ErrorView from './order-details/not_found';
import Success from './order-details/success';
import PaymentCallback from './order-details/callback';
import { Campaign } from './interface';
import { extendTheme } from '@chakra-ui/react'

export const GlobalContext = createContext<{ get: Campaign | null, set: (campaign: Partial<Campaign>) => void } | null>(null);


const theme = extendTheme({
  fonts: {
    heading: `'Inter', sans-serif`,
    body: `'Inter', sans-serif`,
  },
})


const router = createBrowserRouter([
  {
    path: '/',
    element: <ErrorView />
  },
  {
    path: "/:id",
    element: <CampaignDetails />,
  },
  {
    path: "pay4me/:id",
    element: <CampaignDetails />,
  },
  {
    path: "p/:id",
    element: <CampaignDetails />,
  },
  {
    path: 'pay/:id',
    element: <CampaignPayment />
  },
  {
    // Payment callback route - Paystack redirects here after payment
    path: 'callback',
    element: <PaymentCallback />
  },
  {
    path: 'success',
    element: <Success />
  }
]);

function App() {
  const [details, setDetails] = useState(localStorage.getItem('MOTITO') == null ? null : JSON.parse(localStorage.getItem('MOTITO')!));

  const setCampaign = useCallback((arg: Partial<Campaign>) => {
    setDetails(arg as any);
    localStorage.setItem('MOTITO', JSON.stringify(arg));
  }, []);

  const contextValue = useMemo(() => {
    return { get: details, set: setCampaign };
  }, [details, setCampaign]);

  return (
    <GlobalContext.Provider value={contextValue} >

      <ChakraProvider theme={theme}>
        <RouterProvider router={router} />
      </ChakraProvider >
    </GlobalContext.Provider>

  );
}

export default App;
